module.exports = __webpack_public_path__ + "sound/stress.mp3";